export default __webpack_public_path__ + "static/media/relyingTechnology.e33371c4.jpg";